<script setup lang="ts">
import { AppLink } from '#components'
import { useDynamicIcons } from '~layers/shared/utils/useDynamicIcons.ts'

const props = withDefaults(defineProps<{
  usps: array
  horizontal?: boolean
  placement?: string
}>(), {
  horizontal: () => false,
  placement: () => '',
})

const activeIndex = ref(0)
let interval: NodeJS.Timeout | null = null

const placementClass = computed(() => {
  return props.placement ? 'usps--' + props.placement : undefined
})

onMounted(() => {
  if (props.usps) {
    interval = setInterval(() => {
      activeIndex.value++
      if (activeIndex.value >= props.usps.length) {
        activeIndex.value = 0
      }
    }, 5000)
  }
})

onUnmounted(() => {
  if (interval) {
    clearInterval(interval)
    interval = null
  }
})

const label = (usp) => {
  if (!usp?.Description?.length) {
    return usp.Label
  }
  return usp.Description
}

const getElement = (url: string | null) => {
  return url ? AppLink : 'span'
}

const { loadIcon } = useDynamicIcons()
</script>

<template>
  <div
    v-if="usps?.length"
    class="usps"
    :class="placementClass"
  >
    <slot />
    <ul
      class="usps__list"
      :class="{
        'usps--horizontal': horizontal,
        'usps--vertical': !horizontal,
      }"
    >
      <li
        v-for="(usp, index) in usps"
        :key="index"
        class="usps__item"
        :class="{ 'usps__item--active': index === activeIndex }"
      >
        <Icon
          v-if="usp.Icon"
          :name="loadIcon(usp.Icon || 'check')"
        />

        <component
          :is="getElement(usp.Link)"
          :to="usp.Link"
          class="usps__label"
        >
          {{ label(usp) }}
        </component>
      </li>
    </ul>
  </div>
</template>

<style>
@import url("~layers/app/components/App/Usps.css");
</style>
